/**
 * PlanetLayerControls — small overlay on the globe. Single toggle:
 * Resources ON swaps to the resource heatmap, OFF shows terrain.
 * Shows a spinner while the texture is baking.
 */

import { useState } from 'react';
import { usePlanetPanelStore } from './state/planetPanelStore';
import ScaleLoader from 'react-spinners/ScaleLoader';

export function PlanetLayerControls() {
  const resourcesOn = usePlanetPanelStore((s) => s.layers.noise);
  const toggle = usePlanetPanelStore((s) => s.toggleLayer);
  const [baking, setBaking] = useState(false);

  // Show spinner FIRST, then toggle after the browser has painted it.
  // The bake is synchronous and blocks the main thread, so without this
  // delay React never gets to paint the spinner before the freeze.
  const handleClick = () => {
    if (baking) return;
    setBaking(true);
    // Use double-rAF to guarantee the spinner is painted before the bake starts.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        toggle('noise');
        // Clear spinner after one more frame (bake is done by now).
        requestAnimationFrame(() => setBaking(false));
      });
    });
  };

  return (
    <div style={containerStyle}>
      <button style={rowStyle} onClick={handleClick} disabled={baking}>
        <span
          style={{
            display: 'inline-block',
            width: 12,
            height: 12,
            borderRadius: 2,
            marginRight: 8,
            background: resourcesOn ? '#a07cd8' : 'transparent',
            border: '2px solid #a07cd8',
            transition: 'background 0.15s',
          }}
        />
        {baking ? (
          <span style={{ display: 'flex', alignItems: 'center', color: '#a07cd8' }}>
            <ScaleLoader color="#a07cd8" height={12} width={2} radius={1} margin={1} />
            <span style={{ marginLeft: 6 }}>Loading…</span>
          </span>
        ) : (
          <span style={{ color: resourcesOn ? '#f5e8d1' : '#5a6a7a' }}>Resources</span>
        )}
      </button>

    </div>
  );
}

const containerStyle: React.CSSProperties = {
  position: 'absolute',
  bottom: 16,
  left: 16,
  padding: '8px 14px',
  background: 'rgba(15, 27, 38, 0.85)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: 6,
  fontFamily: "'JetBrains Mono', monospace",
  fontSize: 11,
  zIndex: 10,
  pointerEvents: 'auto',
};

const rowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  background: 'none',
  border: 'none',
  padding: '2px 0',
  cursor: 'pointer',
  fontFamily: "'JetBrains Mono', monospace",
  fontSize: 11,
};


